// =============================================================================
// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// =============================================================================
// Generated by: npx tsx scripts/generate-icon-registry.ts
// Generated at: 2026-11-03T21:29:23.021Z
// Total icons: 377
// =============================================================================

import type { Icon } from "@tabler/icons-react";
import {
  IconAccessible,
  IconAddressBook,
  IconAdjustments,
  IconAirConditioning,
  IconAlertCircle,
  IconAlertOctagon,
  IconAlertTriangle,
  IconAlignLeft,
  IconApi,
  IconArchive,
  IconArchiveOff,
  IconArmchair,
  IconArrowBackUp,
  IconArrowDown,
  IconArrowDownRight,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconArrowUpRight,
  IconArrowsExchange,
  IconArrowsLeftRight,
  IconArrowsMaximize,
  IconArrowsSort,
  IconAtom,
  IconAward,
  IconBabyCarriage,
  IconBackpack,
  IconBadgeWc,
  IconBallBasketball,
  IconBallFootball,
  IconBalloon,
  IconBan,
  IconBath,
  IconBatteryCharging,
  IconBeach,
  IconBed,
  IconBeer,
  IconBell,
  IconBike,
  IconBolt,
  IconBook,
  IconBooks,
  IconBottle,
  IconBowling,
  IconBraces,
  IconBrandAirbnb,
  IconBrandAws,
  IconBrandAzure,
  IconBrandFacebook,
  IconBrandGithub,
  IconBrandGoogleDrive,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandMastodon,
  IconBrandReddit,
  IconBrandSlack,
  IconBrandTelegram,
  IconBrandThreads,
  IconBrandTiktok,
  IconBrandWhatsapp,
  IconBrandX,
  IconBrandYoutube,
  IconBread,
  IconBriefcase,
  IconBrush,
  IconBuilding,
  IconBuildingBank,
  IconBuildingCircus,
  IconBuildingCommunity,
  IconBuildingCottage,
  IconBuildingEstate,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconBulb,
  IconBulbOff,
  IconBus,
  IconBusinessplan,
  IconCake,
  IconCalculator,
  IconCalendar,
  IconCalendarDue,
  IconCalendarEvent,
  IconCalendarMinus,
  IconCalendarPlus,
  IconCalendarStats,
  IconCalendarTime,
  IconCamera,
  IconCameraOff,
  IconCameraRotate,
  IconCar,
  IconCarGarage,
  IconCarOff,
  IconCards,
  IconCash,
  IconCat,
  IconCertificate,
  IconChartBar,
  IconCheck,
  IconCheckbox,
  IconChecklist,
  IconCheese,
  IconChefHat,
  IconChess,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircle,
  IconCircleCheck,
  IconCircleOff,
  IconCirclePlus,
  IconCircleX,
  IconClick,
  IconClipboardCheck,
  IconClipboardList,
  IconClock,
  IconClockPlus,
  IconCloud,
  IconCloudDownload,
  IconCloudFog,
  IconCloudRain,
  IconCloudSnow,
  IconCloudStorm,
  IconCode,
  IconCoffee,
  IconCoin,
  IconCoins,
  IconColorPicker,
  IconConfetti,
  IconCopy,
  IconCreditCard,
  IconCrown,
  IconCup,
  IconCurrencyDollar,
  IconCurrentLocation,
  IconDashboard,
  IconDatabase,
  IconDeviceFloppy,
  IconDeviceGamepad,
  IconDeviceGamepad2,
  IconDeviceLaptop,
  IconDeviceMobile,
  IconDeviceTv,
  IconDiamond,
  IconDice,
  IconDice5,
  IconDisc,
  IconDiscount,
  IconDog,
  IconDoor,
  IconDoorEnter,
  IconDots,
  IconDotsCircleHorizontal,
  IconDotsVertical,
  IconDownload,
  IconDroplet,
  IconEdit,
  IconElevator,
  IconEngine,
  IconEraser,
  IconExternalLink,
  IconEye,
  IconEyeOff,
  IconEyeglass,
  IconFile,
  IconFileCertificate,
  IconFileDescription,
  IconFileText,
  IconFileTypePdf,
  IconFileUpload,
  IconFileX,
  IconFilter,
  IconFirstAidKit,
  IconFlag,
  IconFlame,
  IconFlipHorizontal,
  IconFlipVertical,
  IconFlower,
  IconFocusCentered,
  IconFolder,
  IconFolderOpen,
  IconForms,
  IconFrame,
  IconGasStation,
  IconGauge,
  IconGavel,
  IconGift,
  IconGlass,
  IconGlassFull,
  IconGlobe,
  IconGripHorizontal,
  IconGripVertical,
  IconGuitarPick,
  IconHandStop,
  IconHanger,
  IconHash,
  IconHeadphones,
  IconHeart,
  IconHeartHandshake,
  IconHeartRateMonitor,
  IconHelp,
  IconHighlight,
  IconHistory,
  IconHome,
  IconHome2,
  IconHourglass,
  IconIceCream,
  IconId,
  IconInbox,
  IconInfoCircle,
  IconKey,
  IconKeyboard,
  IconLayoutDashboard,
  IconLayoutGrid,
  IconLeaf,
  IconLink,
  IconList,
  IconListCheck,
  IconListDetails,
  IconLoader,
  IconLoader2,
  IconLock,
  IconLockOpen,
  IconLogin,
  IconLogout,
  IconMail,
  IconMap,
  IconMapPin,
  IconMapPin2,
  IconMapPinCog,
  IconMapPinPlus,
  IconMarkdown,
  IconMask,
  IconMassage,
  IconMaximize,
  IconMeat,
  IconMenu,
  IconMessage,
  IconMessageCircle,
  IconMicrophone,
  IconMicrophone2,
  IconMinimize,
  IconMinus,
  IconMoodKid,
  IconMoodSmile,
  IconMoon,
  IconMotorbike,
  IconMovie,
  IconMusic,
  IconNotebook,
  IconNotes,
  IconNumber,
  IconPackage,
  IconPackageExport,
  IconPackageImport,
  IconPackages,
  IconPalette,
  IconPaperclip,
  IconParking,
  IconParkingCircle,
  IconParkingOff,
  IconPaw,
  IconPencil,
  IconPercentage,
  IconPhone,
  IconPhoto,
  IconPigMoney,
  IconPizza,
  IconPlane,
  IconPlayCard,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlaylist,
  IconPlus,
  IconPoint,
  IconPool,
  IconPrinter,
  IconPuzzle,
  IconQrcode,
  IconQuestionMark,
  IconQuote,
  IconRadio,
  IconRainbow,
  IconReceipt,
  IconReceiptTax,
  IconRecycle,
  IconRefresh,
  IconReportMoney,
  IconRoad,
  IconRocket,
  IconRosetteDiscount,
  IconRotate,
  IconRotateClockwise,
  IconRoute,
  IconRuler2,
  IconRun,
  IconSalad,
  IconScan,
  IconSchool,
  IconSearch,
  IconSelector,
  IconSend,
  IconSeparatorHorizontal,
  IconSettings,
  IconShare,
  IconShield,
  IconShieldCheck,
  IconShip,
  IconShirt,
  IconShoppingBag,
  IconShoppingCart,
  IconSignature,
  IconSmoking,
  IconSmokingNo,
  IconSnowflake,
  IconSortAscending,
  IconSortDescending,
  IconSparkles,
  IconSpeakerphone,
  IconSquareCheck,
  IconStairs,
  IconStar,
  IconStarFilled,
  IconSticker,
  IconStopwatch,
  IconSun,
  IconSwimming,
  IconTable,
  IconTag,
  IconTarget,
  IconTemperature,
  IconTent,
  IconTextCaption,
  IconTextSize,
  IconThumbDown,
  IconThumbUp,
  IconTicket,
  IconTimeline,
  IconToggleLeft,
  IconToggleRight,
  IconTool,
  IconTools,
  IconToolsKitchen2,
  IconTrain,
  IconTrash,
  IconTrophy,
  IconUnlink,
  IconUpload,
  IconUser,
  IconUserCheck,
  IconUserCircle,
  IconUserEdit,
  IconUserMinus,
  IconUserPlus,
  IconUserQuestion,
  IconUserStar,
  IconUserX,
  IconUsers,
  IconUsersGroup,
  IconVector,
  IconVideo,
  IconVinyl,
  IconVolume,
  IconVolumeOff,
  IconWallet,
  IconWand,
  IconWebhook,
  IconWheel,
  IconWheelchair,
  IconWhirl,
  IconWifi,
  IconWind,
  IconWorld,
  IconX,
  IconYoga,
  IconZoomIn,
  IconZoomOut
} from "@tabler/icons-react";

/**
 * Registry of icons used in the application.
 *
 * This includes:
 * - Icons detected by scanning <AppIcon iconName="..." /> in source code
 * - Icons manually specified in scripts/icons.config.ts
 *
 * To add new icons:
 * 1. Use them in code with <AppIcon iconName="CirclePlus" /> where "CirclePlus" is an example name of a new icon
 * 2. Or add to manualIcons in scripts/icons.config.ts
 * 3. Run: npm run icons
 */
export const IconRegistry: Record<string, Icon> = {
  "Accessible": IconAccessible,
  "AddressBook": IconAddressBook,
  "Adjustments": IconAdjustments,
  "AirConditioning": IconAirConditioning,
  "AlertCircle": IconAlertCircle,
  "AlertOctagon": IconAlertOctagon,
  "AlertTriangle": IconAlertTriangle,
  "AlignLeft": IconAlignLeft,
  "Api": IconApi,
  "Archive": IconArchive,
  "ArchiveOff": IconArchiveOff,
  "Armchair": IconArmchair,
  "ArrowBackUp": IconArrowBackUp,
  "ArrowDown": IconArrowDown,
  "ArrowDownRight": IconArrowDownRight,
  "ArrowLeft": IconArrowLeft,
  "ArrowRight": IconArrowRight,
  "ArrowUp": IconArrowUp,
  "ArrowUpRight": IconArrowUpRight,
  "ArrowsExchange": IconArrowsExchange,
  "ArrowsLeftRight": IconArrowsLeftRight,
  "ArrowsMaximize": IconArrowsMaximize,
  "ArrowsSort": IconArrowsSort,
  "Atom": IconAtom,
  "Award": IconAward,
  "BabyCarriage": IconBabyCarriage,
  "Backpack": IconBackpack,
  "BadgeWc": IconBadgeWc,
  "BallBasketball": IconBallBasketball,
  "BallFootball": IconBallFootball,
  "Balloon": IconBalloon,
  "Ban": IconBan,
  "Bath": IconBath,
  "BatteryCharging": IconBatteryCharging,
  "Beach": IconBeach,
  "Bed": IconBed,
  "Beer": IconBeer,
  "Bell": IconBell,
  "Bike": IconBike,
  "Bolt": IconBolt,
  "Book": IconBook,
  "Books": IconBooks,
  "Bottle": IconBottle,
  "Bowling": IconBowling,
  "Braces": IconBraces,
  "BrandAirbnb": IconBrandAirbnb,
  "BrandAws": IconBrandAws,
  "BrandAzure": IconBrandAzure,
  "BrandFacebook": IconBrandFacebook,
  "BrandGithub": IconBrandGithub,
  "BrandGoogleDrive": IconBrandGoogleDrive,
  "BrandInstagram": IconBrandInstagram,
  "BrandLinkedin": IconBrandLinkedin,
  "BrandMastodon": IconBrandMastodon,
  "BrandReddit": IconBrandReddit,
  "BrandSlack": IconBrandSlack,
  "BrandTelegram": IconBrandTelegram,
  "BrandThreads": IconBrandThreads,
  "BrandTiktok": IconBrandTiktok,
  "BrandWhatsapp": IconBrandWhatsapp,
  "BrandX": IconBrandX,
  "BrandYoutube": IconBrandYoutube,
  "Bread": IconBread,
  "Briefcase": IconBriefcase,
  "Brush": IconBrush,
  "Building": IconBuilding,
  "BuildingBank": IconBuildingBank,
  "BuildingCircus": IconBuildingCircus,
  "BuildingCommunity": IconBuildingCommunity,
  "BuildingCottage": IconBuildingCottage,
  "BuildingEstate": IconBuildingEstate,
  "BuildingSkyscraper": IconBuildingSkyscraper,
  "BuildingWarehouse": IconBuildingWarehouse,
  "Bulb": IconBulb,
  "BulbOff": IconBulbOff,
  "Bus": IconBus,
  "Businessplan": IconBusinessplan,
  "Cake": IconCake,
  "Calculator": IconCalculator,
  "Calendar": IconCalendar,
  "CalendarDue": IconCalendarDue,
  "CalendarEvent": IconCalendarEvent,
  "CalendarMinus": IconCalendarMinus,
  "CalendarPlus": IconCalendarPlus,
  "CalendarStats": IconCalendarStats,
  "CalendarTime": IconCalendarTime,
  "Camera": IconCamera,
  "CameraOff": IconCameraOff,
  "CameraRotate": IconCameraRotate,
  "Car": IconCar,
  "CarGarage": IconCarGarage,
  "CarOff": IconCarOff,
  "Cards": IconCards,
  "Cash": IconCash,
  "Cat": IconCat,
  "Certificate": IconCertificate,
  "ChartBar": IconChartBar,
  "Check": IconCheck,
  "Checkbox": IconCheckbox,
  "Checklist": IconChecklist,
  "Cheese": IconCheese,
  "ChefHat": IconChefHat,
  "Chess": IconChess,
  "ChevronDown": IconChevronDown,
  "ChevronLeft": IconChevronLeft,
  "ChevronRight": IconChevronRight,
  "ChevronUp": IconChevronUp,
  "Circle": IconCircle,
  "CircleCheck": IconCircleCheck,
  "CircleOff": IconCircleOff,
  "CirclePlus": IconCirclePlus,
  "CircleX": IconCircleX,
  "Click": IconClick,
  "ClipboardCheck": IconClipboardCheck,
  "ClipboardList": IconClipboardList,
  "Clock": IconClock,
  "ClockPlus": IconClockPlus,
  "Cloud": IconCloud,
  "CloudDownload": IconCloudDownload,
  "CloudFog": IconCloudFog,
  "CloudRain": IconCloudRain,
  "CloudSnow": IconCloudSnow,
  "CloudStorm": IconCloudStorm,
  "Code": IconCode,
  "Coffee": IconCoffee,
  "Coin": IconCoin,
  "Coins": IconCoins,
  "ColorPicker": IconColorPicker,
  "Confetti": IconConfetti,
  "Copy": IconCopy,
  "CreditCard": IconCreditCard,
  "Crown": IconCrown,
  "Cup": IconCup,
  "CurrencyDollar": IconCurrencyDollar,
  "CurrentLocation": IconCurrentLocation,
  "Dashboard": IconDashboard,
  "Database": IconDatabase,
  "DeviceFloppy": IconDeviceFloppy,
  "DeviceGamepad": IconDeviceGamepad,
  "DeviceGamepad2": IconDeviceGamepad2,
  "DeviceLaptop": IconDeviceLaptop,
  "DeviceMobile": IconDeviceMobile,
  "DeviceTv": IconDeviceTv,
  "Diamond": IconDiamond,
  "Dice": IconDice,
  "Dice5": IconDice5,
  "Disc": IconDisc,
  "Discount": IconDiscount,
  "Dog": IconDog,
  "Door": IconDoor,
  "DoorEnter": IconDoorEnter,
  "Dots": IconDots,
  "DotsCircleHorizontal": IconDotsCircleHorizontal,
  "DotsVertical": IconDotsVertical,
  "Download": IconDownload,
  "Droplet": IconDroplet,
  "Edit": IconEdit,
  "Elevator": IconElevator,
  "Engine": IconEngine,
  "Eraser": IconEraser,
  "ExternalLink": IconExternalLink,
  "Eye": IconEye,
  "EyeOff": IconEyeOff,
  "Eyeglass": IconEyeglass,
  "File": IconFile,
  "FileCertificate": IconFileCertificate,
  "FileDescription": IconFileDescription,
  "FileText": IconFileText,
  "FileTypePdf": IconFileTypePdf,
  "FileUpload": IconFileUpload,
  "FileX": IconFileX,
  "Filter": IconFilter,
  "FirstAidKit": IconFirstAidKit,
  "Flag": IconFlag,
  "Flame": IconFlame,
  "FlipHorizontal": IconFlipHorizontal,
  "FlipVertical": IconFlipVertical,
  "Flower": IconFlower,
  "FocusCentered": IconFocusCentered,
  "Folder": IconFolder,
  "FolderOpen": IconFolderOpen,
  "Forms": IconForms,
  "Frame": IconFrame,
  "GasStation": IconGasStation,
  "Gauge": IconGauge,
  "Gavel": IconGavel,
  "Gift": IconGift,
  "Glass": IconGlass,
  "GlassFull": IconGlassFull,
  "Globe": IconGlobe,
  "GripHorizontal": IconGripHorizontal,
  "GripVertical": IconGripVertical,
  "GuitarPick": IconGuitarPick,
  "HandStop": IconHandStop,
  "Hanger": IconHanger,
  "Hash": IconHash,
  "Headphones": IconHeadphones,
  "Heart": IconHeart,
  "HeartHandshake": IconHeartHandshake,
  "HeartRateMonitor": IconHeartRateMonitor,
  "Help": IconHelp,
  "Highlight": IconHighlight,
  "History": IconHistory,
  "Home": IconHome,
  "Home2": IconHome2,
  "Hourglass": IconHourglass,
  "IceCream": IconIceCream,
  "Id": IconId,
  "Inbox": IconInbox,
  "InfoCircle": IconInfoCircle,
  "Key": IconKey,
  "Keyboard": IconKeyboard,
  "LayoutDashboard": IconLayoutDashboard,
  "LayoutGrid": IconLayoutGrid,
  "Leaf": IconLeaf,
  "Link": IconLink,
  "List": IconList,
  "ListCheck": IconListCheck,
  "ListDetails": IconListDetails,
  "Loader": IconLoader,
  "Loader2": IconLoader2,
  "Lock": IconLock,
  "LockOpen": IconLockOpen,
  "Login": IconLogin,
  "Logout": IconLogout,
  "Mail": IconMail,
  "Map": IconMap,
  "MapPin": IconMapPin,
  "MapPin2": IconMapPin2,
  "MapPinCog": IconMapPinCog,
  "MapPinPlus": IconMapPinPlus,
  "Markdown": IconMarkdown,
  "Mask": IconMask,
  "Massage": IconMassage,
  "Maximize": IconMaximize,
  "Meat": IconMeat,
  "Menu": IconMenu,
  "Message": IconMessage,
  "MessageCircle": IconMessageCircle,
  "Microphone": IconMicrophone,
  "Microphone2": IconMicrophone2,
  "Minimize": IconMinimize,
  "Minus": IconMinus,
  "MoodKid": IconMoodKid,
  "MoodSmile": IconMoodSmile,
  "Moon": IconMoon,
  "Motorbike": IconMotorbike,
  "Movie": IconMovie,
  "Music": IconMusic,
  "Notebook": IconNotebook,
  "Notes": IconNotes,
  "Number": IconNumber,
  "Package": IconPackage,
  "PackageExport": IconPackageExport,
  "PackageImport": IconPackageImport,
  "Packages": IconPackages,
  "Palette": IconPalette,
  "Paperclip": IconPaperclip,
  "Parking": IconParking,
  "ParkingCircle": IconParkingCircle,
  "ParkingOff": IconParkingOff,
  "Paw": IconPaw,
  "Pencil": IconPencil,
  "Percentage": IconPercentage,
  "Phone": IconPhone,
  "Photo": IconPhoto,
  "PigMoney": IconPigMoney,
  "Pizza": IconPizza,
  "Plane": IconPlane,
  "PlayCard": IconPlayCard,
  "PlayerPause": IconPlayerPause,
  "PlayerPlay": IconPlayerPlay,
  "Playlist": IconPlaylist,
  "Plus": IconPlus,
  "Point": IconPoint,
  "Pool": IconPool,
  "Printer": IconPrinter,
  "Puzzle": IconPuzzle,
  "Qrcode": IconQrcode,
  "QuestionMark": IconQuestionMark,
  "Quote": IconQuote,
  "Radio": IconRadio,
  "Rainbow": IconRainbow,
  "Receipt": IconReceipt,
  "ReceiptTax": IconReceiptTax,
  "Recycle": IconRecycle,
  "Refresh": IconRefresh,
  "ReportMoney": IconReportMoney,
  "Road": IconRoad,
  "Rocket": IconRocket,
  "RosetteDiscount": IconRosetteDiscount,
  "Rotate": IconRotate,
  "RotateClockwise": IconRotateClockwise,
  "Route": IconRoute,
  "Ruler2": IconRuler2,
  "Run": IconRun,
  "Salad": IconSalad,
  "Scan": IconScan,
  "School": IconSchool,
  "Search": IconSearch,
  "Selector": IconSelector,
  "Send": IconSend,
  "SeparatorHorizontal": IconSeparatorHorizontal,
  "Settings": IconSettings,
  "Share": IconShare,
  "Shield": IconShield,
  "ShieldCheck": IconShieldCheck,
  "Ship": IconShip,
  "Shirt": IconShirt,
  "ShoppingBag": IconShoppingBag,
  "ShoppingCart": IconShoppingCart,
  "Signature": IconSignature,
  "Smoking": IconSmoking,
  "SmokingNo": IconSmokingNo,
  "Snowflake": IconSnowflake,
  "SortAscending": IconSortAscending,
  "SortDescending": IconSortDescending,
  "Sparkles": IconSparkles,
  "Speakerphone": IconSpeakerphone,
  "SquareCheck": IconSquareCheck,
  "Stairs": IconStairs,
  "Star": IconStar,
  "StarFilled": IconStarFilled,
  "Sticker": IconSticker,
  "Stopwatch": IconStopwatch,
  "Sun": IconSun,
  "Swimming": IconSwimming,
  "Table": IconTable,
  "Tag": IconTag,
  "Target": IconTarget,
  "Temperature": IconTemperature,
  "Tent": IconTent,
  "TextCaption": IconTextCaption,
  "TextSize": IconTextSize,
  "ThumbDown": IconThumbDown,
  "ThumbUp": IconThumbUp,
  "Ticket": IconTicket,
  "Timeline": IconTimeline,
  "ToggleLeft": IconToggleLeft,
  "ToggleRight": IconToggleRight,
  "Tool": IconTool,
  "Tools": IconTools,
  "ToolsKitchen2": IconToolsKitchen2,
  "Train": IconTrain,
  "Trash": IconTrash,
  "Trophy": IconTrophy,
  "Unlink": IconUnlink,
  "Upload": IconUpload,
  "User": IconUser,
  "UserCheck": IconUserCheck,
  "UserCircle": IconUserCircle,
  "UserEdit": IconUserEdit,
  "UserMinus": IconUserMinus,
  "UserPlus": IconUserPlus,
  "UserQuestion": IconUserQuestion,
  "UserStar": IconUserStar,
  "UserX": IconUserX,
  "Users": IconUsers,
  "UsersGroup": IconUsersGroup,
  "Vector": IconVector,
  "Video": IconVideo,
  "Vinyl": IconVinyl,
  "Volume": IconVolume,
  "VolumeOff": IconVolumeOff,
  "Wallet": IconWallet,
  "Wand": IconWand,
  "Webhook": IconWebhook,
  "Wheel": IconWheel,
  "Wheelchair": IconWheelchair,
  "Whirl": IconWhirl,
  "Wifi": IconWifi,
  "Wind": IconWind,
  "World": IconWorld,
  "X": IconX,
  "Yoga": IconYoga,
  "ZoomIn": IconZoomIn,
  "ZoomOut": IconZoomOut,
};

/**
 * Fallback icon shown when requested icon doesn't exist
 */
export const FallbackIcon = IconQuestionMark;

/**
 * Check if an icon exists in the registry
 */
export function hasIcon(name: string): boolean {
  return name in IconRegistry;
}

/**
 * Get an icon from the registry (with fallback)
 */
export function getIcon(name: string): Icon {
  return IconRegistry[name] || FallbackIcon;
}

/**
 * List of all available icon names
 */
export const availableIcons: string[] = [
  "Accessible",
  "AddressBook",
  "Adjustments",
  "AirConditioning",
  "AlertCircle",
  "AlertOctagon",
  "AlertTriangle",
  "AlignLeft",
  "Api",
  "Archive",
  "ArchiveOff",
  "Armchair",
  "ArrowBackUp",
  "ArrowDown",
  "ArrowDownRight",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowUpRight",
  "ArrowsExchange",
  "ArrowsLeftRight",
  "ArrowsMaximize",
  "ArrowsSort",
  "Atom",
  "Award",
  "BabyCarriage",
  "Backpack",
  "BadgeWc",
  "BallBasketball",
  "BallFootball",
  "Balloon",
  "Ban",
  "Bath",
  "BatteryCharging",
  "Beach",
  "Bed",
  "Beer",
  "Bell",
  "Bike",
  "Bolt",
  "Book",
  "Books",
  "Bottle",
  "Bowling",
  "Braces",
  "BrandAirbnb",
  "BrandAws",
  "BrandAzure",
  "BrandFacebook",
  "BrandGithub",
  "BrandGoogleDrive",
  "BrandInstagram",
  "BrandLinkedin",
  "BrandMastodon",
  "BrandReddit",
  "BrandSlack",
  "BrandTelegram",
  "BrandThreads",
  "BrandTiktok",
  "BrandWhatsapp",
  "BrandX",
  "BrandYoutube",
  "Bread",
  "Briefcase",
  "Brush",
  "Building",
  "BuildingBank",
  "BuildingCircus",
  "BuildingCommunity",
  "BuildingCottage",
  "BuildingEstate",
  "BuildingSkyscraper",
  "BuildingWarehouse",
  "Bulb",
  "BulbOff",
  "Bus",
  "Businessplan",
  "Cake",
  "Calculator",
  "Calendar",
  "CalendarDue",
  "CalendarEvent",
  "CalendarMinus",
  "CalendarPlus",
  "CalendarStats",
  "CalendarTime",
  "Camera",
  "CameraOff",
  "CameraRotate",
  "Car",
  "CarGarage",
  "CarOff",
  "Cards",
  "Cash",
  "Cat",
  "Certificate",
  "ChartBar",
  "Check",
  "Checkbox",
  "Checklist",
  "Cheese",
  "ChefHat",
  "Chess",
  "ChevronDown",
  "ChevronLeft",
  "ChevronRight",
  "ChevronUp",
  "Circle",
  "CircleCheck",
  "CircleOff",
  "CirclePlus",
  "CircleX",
  "Click",
  "ClipboardCheck",
  "ClipboardList",
  "Clock",
  "ClockPlus",
  "Cloud",
  "CloudDownload",
  "CloudFog",
  "CloudRain",
  "CloudSnow",
  "CloudStorm",
  "Code",
  "Coffee",
  "Coin",
  "Coins",
  "ColorPicker",
  "Confetti",
  "Copy",
  "CreditCard",
  "Crown",
  "Cup",
  "CurrencyDollar",
  "CurrentLocation",
  "Dashboard",
  "Database",
  "DeviceFloppy",
  "DeviceGamepad",
  "DeviceGamepad2",
  "DeviceLaptop",
  "DeviceMobile",
  "DeviceTv",
  "Diamond",
  "Dice",
  "Dice5",
  "Disc",
  "Discount",
  "Dog",
  "Door",
  "DoorEnter",
  "Dots",
  "DotsCircleHorizontal",
  "DotsVertical",
  "Download",
  "Droplet",
  "Edit",
  "Elevator",
  "Engine",
  "Eraser",
  "ExternalLink",
  "Eye",
  "EyeOff",
  "Eyeglass",
  "File",
  "FileCertificate",
  "FileDescription",
  "FileText",
  "FileTypePdf",
  "FileUpload",
  "FileX",
  "Filter",
  "FirstAidKit",
  "Flag",
  "Flame",
  "FlipHorizontal",
  "FlipVertical",
  "Flower",
  "FocusCentered",
  "Folder",
  "FolderOpen",
  "Forms",
  "Frame",
  "GasStation",
  "Gauge",
  "Gavel",
  "Gift",
  "Glass",
  "GlassFull",
  "Globe",
  "GripHorizontal",
  "GripVertical",
  "GuitarPick",
  "HandStop",
  "Hanger",
  "Hash",
  "Headphones",
  "Heart",
  "HeartHandshake",
  "HeartRateMonitor",
  "Help",
  "Highlight",
  "History",
  "Home",
  "Home2",
  "Hourglass",
  "IceCream",
  "Id",
  "Inbox",
  "InfoCircle",
  "Key",
  "Keyboard",
  "LayoutDashboard",
  "LayoutGrid",
  "Leaf",
  "Link",
  "List",
  "ListCheck",
  "ListDetails",
  "Loader",
  "Loader2",
  "Lock",
  "LockOpen",
  "Login",
  "Logout",
  "Mail",
  "Map",
  "MapPin",
  "MapPin2",
  "MapPinCog",
  "MapPinPlus",
  "Markdown",
  "Mask",
  "Massage",
  "Maximize",
  "Meat",
  "Menu",
  "Message",
  "MessageCircle",
  "Microphone",
  "Microphone2",
  "Minimize",
  "Minus",
  "MoodKid",
  "MoodSmile",
  "Moon",
  "Motorbike",
  "Movie",
  "Music",
  "Notebook",
  "Notes",
  "Number",
  "Package",
  "PackageExport",
  "PackageImport",
  "Packages",
  "Palette",
  "Paperclip",
  "Parking",
  "ParkingCircle",
  "ParkingOff",
  "Paw",
  "Pencil",
  "Percentage",
  "Phone",
  "Photo",
  "PigMoney",
  "Pizza",
  "Plane",
  "PlayCard",
  "PlayerPause",
  "PlayerPlay",
  "Playlist",
  "Plus",
  "Point",
  "Pool",
  "Printer",
  "Puzzle",
  "Qrcode",
  "QuestionMark",
  "Quote",
  "Radio",
  "Rainbow",
  "Receipt",
  "ReceiptTax",
  "Recycle",
  "Refresh",
  "ReportMoney",
  "Road",
  "Rocket",
  "RosetteDiscount",
  "Rotate",
  "RotateClockwise",
  "Route",
  "Ruler2",
  "Run",
  "Salad",
  "Scan",
  "School",
  "Search",
  "Selector",
  "Send",
  "SeparatorHorizontal",
  "Settings",
  "Share",
  "Shield",
  "ShieldCheck",
  "Ship",
  "Shirt",
  "ShoppingBag",
  "ShoppingCart",
  "Signature",
  "Smoking",
  "SmokingNo",
  "Snowflake",
  "SortAscending",
  "SortDescending",
  "Sparkles",
  "Speakerphone",
  "SquareCheck",
  "Stairs",
  "Star",
  "StarFilled",
  "Sticker",
  "Stopwatch",
  "Sun",
  "Swimming",
  "Table",
  "Tag",
  "Target",
  "Temperature",
  "Tent",
  "TextCaption",
  "TextSize",
  "ThumbDown",
  "ThumbUp",
  "Ticket",
  "Timeline",
  "ToggleLeft",
  "ToggleRight",
  "Tool",
  "Tools",
  "ToolsKitchen2",
  "Train",
  "Trash",
  "Trophy",
  "Unlink",
  "Upload",
  "User",
  "UserCheck",
  "UserCircle",
  "UserEdit",
  "UserMinus",
  "UserPlus",
  "UserQuestion",
  "UserStar",
  "UserX",
  "Users",
  "UsersGroup",
  "Vector",
  "Video",
  "Vinyl",
  "Volume",
  "VolumeOff",
  "Wallet",
  "Wand",
  "Webhook",
  "Wheel",
  "Wheelchair",
  "Whirl",
  "Wifi",
  "Wind",
  "World",
  "X",
  "Yoga",
  "ZoomIn",
  "ZoomOut"
];
